<!--
 * @Description: 学生 详情 成绩信息
 * @Author: PF
 * @Date: 2023-11-30 10:50:08
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:39:53
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="学期" prop="xqmc" align="center" />
      <el-table-column label="科目" prop="kmmc" align="center" />
      <el-table-column label="分数" prop="zzxf" align="center">
        <template #default="scope">
          <span :class="scope.row.sfjg==1?'blek':'red'">{{scope.row.zzxf}}</span>
          <span v-if="scope.row.bkzt == 1">(补考)</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无信息" />
</template>

<script setup>
import { ref, defineProps, watch, computed } from 'vue'
import { loadSelect } from '@/api/common.js'
import { getRowspanMethod } from '@/utils/index.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

const spanMethod = computed(() =>
  getRowspanMethod(tableData.value, ['xqmc'])
)

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/jiaowu/chengjizongpingchengji', data: tableData, parms: { xsid: props.row.id, order: 'xqmc', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
